<div class="shadow-md bg-white w-full flex flex-col max-h-full">
  <div class="flex flex-row justify-between items-center p-8 bg-primary-600 text-contrast overflow-hidden rounded-t-md">
    <h2 class="m-0 font-bold">{{ { key: 'topUpCredit' } | i18n }}</h2>

    <button (click)="close()">
      <ng-icon name="heroXMark" class="h-5 w-5 flex-shrink-0" size="24px"></ng-icon>
    </button>
  </div>

  <div class="p-8 overflow-auto">
    <div class="flex flex-col">
      <label for="credit-amount" class="block text-sm font-bold leading-6 text-gray-900">
        {{ { key: 'requestedCredit' } | i18n }}
      </label>
      <input
        id="credit-amount"
        type="number"
        [(ngModel)]="topUpCredits"
        class="mt-2 block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
      />
      <div class="mt-8">
        <app-credit-table [credits]="topUpCredits()"></app-credit-table>
      </div>
      <div class="mt-8">
        <label for="payment-method-select" class="block text-sm leading-6 text-gray-900 font-bold">
          {{ { key: 'paymentMethod' } | i18n }}
        </label>
        <select
          id="payment-method-select"
          name="payment-method-select"
          class="mt-2 block w-full border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6"
          [(ngModel)]="selectedPaymentMethod"
        >
          @for (item of paymentMethods(); track item._id) {
            <option [value]="item._id">{{ item.displayValue | i18n }}</option>
          }
        </select>
      </div>

      <div class="w-full h-24 flex flex-col justify-center mt-8 text-sm">
        @if (priceResult.isLoading()) {
          <app-loading [noWhitespace]="true"></app-loading>
        } @else if (priceResult.error()) {
          {{ { key: 'error' } | i18n }}
        } @else {
          <div class="flex flex-row justify-between font-bold">
            @if (priceResult.value()?.canBeSold) {
              <span>{{ { key: 'priceInclVat' } | i18n }}:</span><span>{{ priceResult.value()?.text }}</span>
            } @else {
              <span>{{ priceResult.value()?.text || '' | i18n }}</span>
            }
          </div>
        }
      </div>

      <div class="mt-8">
        <p class="text-sm">
          {{ { key: 'creditsAvailabilityDelay' } | i18n }}
        </p>
      </div>

      @if (disableButton() || priceResult.error() || priceResult.isLoading() || !priceResult.value()?.canBeSold) {
        <button
          class="mt-8 w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-gray-300 cursor-not-allowed"
        >
          {{ { key: 'buy' } | i18n }}
        </button>
      } @else {
        <button
          class="mt-8 w-full items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 bg-primary-600 hover:bg-primary-700 focus:ring-primary-500"
          (click)="buy()"
        >
          {{ { key: 'buy' } | i18n }}
        </button>
      }
    </div>
  </div>
</div>
